import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import booleanContains from '@turf/boolean-contains'
import booleanIntersects from '@turf/boolean-intersects'
import { point } from '@turf/helpers'

const getFeaturesAtPoint = ({ features, lng, lat, id, idKey} ) => {
  // if (id && idKey) {
  //   const featuresFiltered = features.filter(feature => feature[idKey] === id)
  //   console.log(features)
  // }
  const point_geometry = point([lng, lat])

  const featuresAtPoint = features.filter(feature => booleanPointInPolygon(point_geometry, feature, {ignoreBoundary: true}))

  // features.filter(feature => console.log(point_geometry, feature.geometry, booleanPointInPolygon(point_geometry, feature, {ignoreBoundary: true})))
  features.filter(feature => console.log(feature.properties.timestamp))
  
  // console.log(features.filter(feature => booleanContains(feature, point_geometry)))

  // console.log(featuresAtPoint)
  return featuresAtPoint
}

export default getFeaturesAtPoint



// WEBPACK FOOTER //
// ./src/utility/getFeaturesAtPoint.js